import { Typography } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDateFormatter } from "~/utils/hooks/useDateFormatter";
import { EventMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type Props = {
  map: Map;
} & (ClickProps | HoverProps);

type ClickProps = {
  clickData: EventMapItem;
  hoverData?: EventMapItem;
};

type HoverProps = {
  hoverData: EventMapItem;
  clickData?: EventMapItem;
};

export const EventPopup = ({
  hoverData,
  clickData,
  map,
}: Props): JSX.Element | null => {
  const { t } = useTranslation("event");
  const dateFormatter = useDateFormatter();

  const data = clickData ?? hoverData;

  if (!data) return null;

  const { name, description, startTimestamp, endTimestamp, eventType } = data;

  return (
    <GenericPopup
      map={map}
      clicked={!!clickData}
      avatarText={eventType?.name?.[0] ?? ""}
      title={name}
      subheader={description}
      content={
        <>
          <Typography variant="body2" align="left" noWrap>
            {`${t("startTimestamp")}: ${dateFormatter({
              date: startTimestamp,
            })}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("endTimestamp")}: ${dateFormatter({ date: endTimestamp })}`}
          </Typography>
        </>
      }
    />
  );
};
